import { Typography, Box, useTheme, Stack } from "@mui/material";
import CountUp from "react-countup";
import IconifyIcon from "../../base/IconifyIcon";

const SummaryCard = ({
  icon,
  title,
  value,
  suffix = "",
  color = "primary",
  duration = 1.5,
  onClick = null,
}) => {
  const theme = useTheme();

  return (
    <Stack
      gap={6}
      p={5}
      borderRadius={4}
      height={1}
      bgcolor="background.default"
    >
      <Box
        sx={{
          width: 56,
          height: 56,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          cursor: onClick ? "pointer" : "default",
          mr: 2,
          p: 1.5,
          borderRadius: "50%",
          bgcolor: theme.palette[color].light,
          color: theme.palette[color].main,
        }}
      >
        <IconifyIcon icon={icon} width={28} height={28} />
      </Box>
      <Box>
        <Typography variant="h4" color="common.white" mb={4}>
          <CountUp
            end={Number(value)}
            duration={duration}
            separator=","
            suffix={suffix}
          />
        </Typography>
        <Typography variant="body1" color="text.secondary" mb={2}>
          {title}
        </Typography>
      </Box>
    </Stack>
  );
};

export default SummaryCard;
